import type { Tutorial } from '../types/project'

/** Added on the projects that sell through Salesforge. */
export const salesforgeAcademy: Tutorial = {
  id: 'salesforge-academy',
  name: 'Salesforge Academy',
  description: 'Training on sequences, deliverability and outbound in Salesforge.',
  url: 'https://app.salesforge.ai/certificates-dev/academy',
  source: 'salesforge.ai',
}

/** Loom walkthroughs of the sales motion, for the conference projects. */
export const salesMotionVideos: Tutorial[] = [
  {
    id: 'sales-motion-1',
    name: 'Sales motion — part 1',
    description: 'Walkthrough of the sales motion, recorded by the team.',
    url: 'https://www.loom.com/share/1935ba6095234e1082f4ffcbc8de599f',
    source: 'loom.com',
    kind: 'video',
  },
  {
    id: 'sales-motion-2',
    name: 'Sales motion — part 2',
    description: 'Walkthrough of the sales motion, recorded by the team.',
    url: 'https://www.loom.com/share/5adc6fe70c924a2492ccb88d18dd88b2',
    source: 'loom.com',
    kind: 'video',
  },
  {
    id: 'sales-motion-3',
    name: 'Sales motion — part 3',
    description: 'Walkthrough of the sales motion, recorded by the team.',
    url: 'https://www.loom.com/share/606a8a4ee76d4a5e8649c0ee6330664d',
    source: 'loom.com',
    kind: 'video',
  },
]

/** Shown on every project — how to use the shared tooling. */
export const tutorials: Tutorial[] = [
  {
    id: 'attio-101',
    name: 'Attio 101',
    description: 'Introduction to records, lists, views and pipelines in Attio.',
    url: 'https://attio.com/help/reference/attio-101/introduction',
    source: 'attio.com',
  },
  {
    id: 'apollo-academy',
    name: 'Apollo Academy',
    description: 'Courses on prospecting, sequences and using Apollo data well.',
    url: 'https://www.apollo.io/academy',
    source: 'apollo.io',
  },
]
